import { useMyExportPreferences, useSaveMyExportPreferences } from "@/hooks/useExportPreferences";
import { useMedChronExportForm } from "@/hooks/useMedChronExportForm";
import { getErrorMessage } from "@/utils/errorUtils";
import toast from "react-hot-toast";

import { PreferencesTabView } from "./PreferencesTabView";

export const PreferencesTab = () => {
  const { uiState, isLoading, isError, errorMessage } = useMyExportPreferences();
  const { formState, isDirty, handleFieldChange, handleReset } = useMedChronExportForm(uiState);
  const { saveMyExportPreferences, isSaving } = useSaveMyExportPreferences();

  const handleSave = () => {
    if (!formState) return;

    saveMyExportPreferences(formState)
      .then(() => toast.success("Preferences saved"))
      .catch((error) => toast.error(getErrorMessage(error)));
  };

  return (
    <PreferencesTabView
      formState={formState}
      isLoading={isLoading}
      isError={isError}
      errorMessage={errorMessage}
      isSaving={isSaving}
      isDirty={isDirty}
      onFieldChange={handleFieldChange}
      onReset={handleReset}
      onSave={handleSave}
    />
  );
};
